import React from 'react';
import { AsyncContent, Button, intl } from 'ehs-react';
import { PortletStoreApi } from '../App';

function AgreementPage({
  title,
  operation,
  onBackClicked
}: Readonly<{
  title: string;
  operation: string;
  onBackClicked: () => void;
}>): React.JSX.Element {
  return (
    <div className="agreement-page">
      <div className="agreement-page-header">
        <div className="agreement-page-header-content">
          <div className="agreement-page-header-icon">
            <img
              src="/o/PatientSelfOnboardingPortlet/images/terms_header.png"
              role="none"
            />
          </div>
          <div className="agreement-page-header-text">
            <h1 className="font-18 center sh-font">{title}</h1>
          </div>
        </div>
      </div>
      <div className="agreement-page-content">
        <AsyncContent
          className="agreement-page-content-iframe-container"
          stateUrl={PortletStoreApi.getState().url}
          operation={operation}
        />
        <div className="content-button-bar">
          <Button
            scale={'medium'}
            text={intl('patientSelfOnboardingPortlet.agreementPage.buttonBack')}
            variant="primary"
            onClick={() => onBackClicked()}
          />
        </div>
      </div>
    </div>
  );
}

export default AgreementPage;
